import { render, staticRenderFns } from "./ClientCalls.vue?vue&type=template&id=6758347e&scoped=true"
import script from "./ClientCalls.vue?vue&type=script&lang=js"
export * from "./ClientCalls.vue?vue&type=script&lang=js"
import style0 from "./ClientCalls.vue?vue&type=style&index=0&id=6758347e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6758347e",
  null
  
)

export default component.exports